import { useRefs } from '../context/RefsContext';
import { initialsOf, personLabel } from '../lib/people';
import { rem } from '../lib/fontSize';

// Palette stable par id : même couleur pour un id donné, distinctes entre
// elles. Teintes foncées et unies (plus de dégradé clair) : lettres blanches
// lisibles, contraste ≥ 4,5:1 sur chaque teinte.
const PALETTE = ['#1d4ed8', '#b45309', '#6d28d9', '#047857', '#be123c', '#0e7490', '#c2410c', '#a21caf'];

function background(id: number): string {
  return PALETTE[Math.abs(id) % PALETTE.length]!;
}

/**
 * Rond à initiales, toujours (retour 3 de Julien, PS 11323) : plus de photo
 * /img/traitant/<id>.jpg. Taille pensée en px à la taille de texte Normale,
 * convertie en rem pour suivre la préférence de l'utilisateur.
 *
 * `name` : nom connu par ailleurs (traitants renvoyés avec le point, utilisateur
 * connecté), pour un lecteur qui n'a pas la liste des traitants (client).
 */
export function UserAvatar({ id, size = 24, stacked, name }: { id: number; size?: number; stacked?: boolean; name?: string }) {
  const { traitantById } = useRefs();
  const nom = traitantById(id)?.nom_user ?? name;
  const ini = initialsOf(nom, id);
  const label = personLabel(nom, id);

  return (
    <span
      title={label}
      role="img"
      aria-label={label}
      style={{
        width: rem(size),
        height: rem(size),
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        overflow: 'hidden',
        ...(stacked ? { border: '2px solid var(--avatar-ring, var(--bg))', marginLeft: rem(-6) } : {}),
        background: background(id),
        color: '#fff',
        fontSize: rem(size * 0.46),
        letterSpacing: '0.01em',
        fontWeight: 700,
        lineHeight: 1,
      }}
    >
      {ini}
    </span>
  );
}

export function UserName({ id, fallback, name }: { id: number; fallback?: string; name?: string }) {
  const { traitantById } = useRefs();
  return <>{personLabel(traitantById(id)?.nom_user ?? name, id, fallback)}</>;
}
